import { Component, Input } from '@angular/core';
import {
  CampaignAccountApiStates,
  CampaignAccountStatus,
} from '../../../../../shared/models/campaign/account-status';

@Component({
  selector: 'app-account-status',
  templateUrl: './account-status.component.html',
  styleUrls: ['./account-status.component.scss'],
  imports: [],
})
export class AccountStatusComponent {
  @Input() status: CampaignAccountStatus;
  @Input() set accountState(state: CampaignAccountApiStates) {
    this.setStatusForDisplay(state);
  }

  setStatusForDisplay(state: CampaignAccountApiStates): void {
    switch (state) {
      case 'ACTIVE':
      case 'RUNNING':
        this.status = 'success';
        break;
      case 'INACTIVE':
      case 'UNAUTHORIZED':
      case 'DISCONNECTED':
      case 'ERRORED':
      case 'DELETED':
        this.status = 'failed';
        break;
      case 'PENDING':
      case 'PARTIAL':
      case 'DEGRADED':
        this.status = 'pending';
        break;
    }
  }
}
